// extracted by mini-css-extract-plugin
export default {"button_root":"button_root__0Azm9","button_contained":"button_contained__AiATD","button_outlined":"button_outlined__VIsTB","ripple":"ripple__c8uby"};